import * as React from 'react';

import { useTheme } from '@/components/ui/theme-provider';

const InboxEmptySvg = () => {
	const { resolvedTheme: theme } = useTheme();

	return (
		<svg
			id="Layer_1"
			data-name="Layer 1"
			xmlns="http://www.w3.org/2000/svg"
			xmlnsXlink="http://www.w3.org/1999/xlink"
			version="1.1"
			viewBox="0 0 1080 1080"
		>
			<defs>
				<style>
					{` .cls-1 {
        fill: url(#linear-gradient);
      }

      .cls-1, .cls-2 {
        stroke: #444;
        stroke-linecap: round;
        stroke-linejoin: round;
        stroke-width: 10px;
      }

      .cls-3 {
        fill: #333;
        opacity: 0;
      }

      .cls-3, .cls-4, .cls-5 {
        stroke-width: 0px;
      }

      .cls-2, .cls-4 {
        fill:  ${theme === 'dark' ? '#000' : '#fff'};
      }

      .cls-5 {
        fill: #444;
      }`}
				</style>
				<linearGradient
					id="linear-gradient"
					x1="486"
					y1="493"
					x2="486"
					y2="979.6"
					gradientUnits="userSpaceOnUse"
				>
					<stop
						offset="0"
						stopColor={`${theme === 'dark' ? '#000' : '#fff'}`}
					/>
					<stop offset="1" stopColor="#444" />
				</linearGradient>
			</defs>
			<path
				className="cls-3"
				d="M906.5,863c-36.7,19.3-52.3.9-138.4,24.3-119.5,32.4-128.9,78.6-224.3,109-17.3,5.5-174.1,53-314.7-32-13-7.8-74.1-46-120-122.7-77.4-129.2-51.5-267.6-42.7-314.7C99.7,349.7,244.5,98.1,503.8,68.4c145.3-16.7,298.7,39.6,397.3,149.3,190.5,211.9,135.6,576.7,5.3,645.3Z"
			/>
			<g>
				<g>
					<polygon
						className="cls-2"
						points="484.8 684.6 484.8 885.4 218.2 785 218.2 584.2 484.8 684.6"
					/>
					<polygon
						className="cls-2"
						points="751.5 584.2 751.5 785 484.8 885.4 484.8 684.6 749.2 585.1 751.5 584.2"
					/>
					<polygon
						className="cls-1"
						points="751.5 584.2 487.2 683.8 220.5 583.4 486.3 483.3 751.5 584.2"
					/>
				</g>
				<g>
					<polygon
						className="cls-2"
						points="861.8 426.7 830.7 708.8 668 477.9 698.2 194.6 861.8 426.7"
					/>
					<polygon
						className="cls-2"
						points="698.2 194.6 668 477.9 618.2 490.8 648.4 207.5 698.2 194.6"
					/>
					<polygon
						className="cls-2"
						points="830.7 708.8 780.9 721.7 618.2 490.8 668 477.9 830.7 708.8"
					/>
				</g>
			</g>
			<g>
				<path
					className="cls-5"
					d="M401.3,567c-13.9,0-25.3-11.3-25.3-25.3s11.3-25.3,25.3-25.3,25.3,11.3,25.3,25.3-11.3,25.3-25.3,25.3ZM401.3,531.5c-5.7,0-10.3,4.6-10.3,10.3s4.6,10.3,10.3,10.3,10.3-4.6,10.3-10.3-4.6-10.3-10.3-10.3Z"
				/>
				<path
					className="cls-4"
					d="M401.3,519c12.6,0,22.8,10.2,22.8,22.8s-10.2,22.8-22.8,22.8-22.8-10.2-22.8-22.8,10.2-22.8,22.8-22.8M401.3,554.5c7,0,12.8-5.7,12.8-12.8s-5.7-12.8-12.8-12.8-12.8,5.7-12.8,12.8,5.7,12.8,12.8,12.8M401.3,514c-15.3,0-27.8,12.5-27.8,27.8s12.5,27.8,27.8,27.8,27.8-12.5,27.8-27.8-12.5-27.8-27.8-27.8h0ZM401.3,549.5c-4.3,0-7.8-3.5-7.8-7.8s3.5-7.8,7.8-7.8,7.8,3.5,7.8,7.8-3.5,7.8-7.8,7.8h0Z"
				/>
			</g>
			<path
				className="cls-5"
				d="M578.5,401.8c-15.1,0-27.3-12.3-27.3-27.3s12.3-27.3,27.3-27.3,27.3,12.3,27.3,27.3-12.3,27.3-27.3,27.3ZM578.5,359.1c-8.5,0-15.3,6.9-15.3,15.3s6.9,15.3,15.3,15.3,15.3-6.9,15.3-15.3-6.9-15.3-15.3-15.3Z"
			/>
			<path
				className="cls-5"
				d="M351.5,430.1c-10,0-18.2-8.2-18.2-18.2s8.2-18.2,18.2-18.2,18.2,8.2,18.2,18.2-8.2,18.2-18.2,18.2ZM351.5,401.8c-5.6,0-10.2,4.6-10.2,10.2s4.6,10.2,10.2,10.2,10.2-4.6,10.2-10.2-4.6-10.2-10.2-10.2Z"
			/>
			<path
				className="cls-5"
				d="M491.4,208.4c-10.2,0-18.5-8.3-18.5-18.5s8.3-18.5,18.5-18.5,18.5,8.3,18.5,18.5-8.3,18.5-18.5,18.5ZM491.4,179.5c-5.7,0-10.4,4.7-10.4,10.4s4.7,10.4,10.4,10.4,10.4-4.7,10.4-10.4-4.7-10.4-10.4-10.4Z"
			/>
			<path
				className="cls-5"
				d="M475.7,442.8c-8.5,0-15.4-6.9-15.4-15.4s6.9-15.4,15.4-15.4,15.4,6.9,15.4,15.4-6.9,15.4-15.4,15.4ZM475.7,418.7c-4.8,0-8.7,3.9-8.7,8.7s3.9,8.7,8.7,8.7,8.7-3.9,8.7-8.7-3.9-8.7-8.7-8.7Z"
			/>
			<g>
				<path
					className="cls-5"
					d="M552.1,530.5c-1.4,0-2.7-.5-3.7-1.5l-2.6-2.6-2.6,2.6c-1,1-2.3,1.5-3.7,1.5s-2.7-.5-3.7-1.5c-2-2-2-5.3,0-7.4l2.6-2.6-2.6-2.6c-2-2-2-5.3,0-7.4,1-1,2.3-1.5,3.7-1.5s2.7.5,3.7,1.5l2.6,2.6,2.6-2.6c1-1,2.3-1.5,3.7-1.5s2.7.5,3.7,1.5c2,2,2,5.3,0,7.4l-2.6,2.6,2.6,2.6c2,2,2,5.3,0,7.4-1,1-2.3,1.5-3.7,1.5Z"
				/>
				<path
					className="cls-4"
					d="M552.1,510c.7,0,1.4.3,1.9.8,1.1,1.1,1.1,2.8,0,3.8l-4.3,4.3,4.3,4.3c1.1,1.1,1.1,2.8,0,3.8-.5.5-1.2.8-1.9.8s-1.4-.3-1.9-.8l-4.3-4.3-4.3,4.3c-.5.5-1.2.8-1.9.8s-1.4-.3-1.9-.8c-1.1-1.1-1.1-2.8,0-3.8l4.3-4.3-4.3-4.3c-1.1-1.1-1.1-2.8,0-3.8.5-.5,1.2-.8,1.9-.8s1.4.3,1.9.8l4.3,4.3,4.3-4.3c.5-.5,1.2-.8,1.9-.8M552.1,505c-2.1,0-4,.8-5.4,2.3l-.8.8-.8-.8c-1.5-1.5-3.4-2.3-5.4-2.3s-4,.8-5.4,2.3c-3,3-3,7.9,0,10.9l.8.8-.8.8c-3,3-3,7.9,0,10.9,1.5,1.5,3.4,2.3,5.5,2.3s4-.8,5.4-2.2l.8-.8.8.8c1.5,1.5,3.4,2.3,5.5,2.3s4-.8,5.4-2.2c3-3,3-7.9,0-10.9l-.8-.8.8-.8c3-3,3-7.9,0-10.9-1.5-1.5-3.4-2.3-5.5-2.3h0Z"
				/>
			</g>
			<g>
				<path
					className="cls-5"
					d="M433,306c-1.5,0-2.7-1.2-2.7-2.7v-17.5c0-1.5,1.2-2.7,2.7-2.7s2.7,1.2,2.7,2.7v17.5c0,1.5-1.2,2.7-2.7,2.7Z"
				/>
				<path
					className="cls-5"
					d="M441.7,297.3h-17.5c-1.5,0-2.7-1.2-2.7-2.7s1.2-2.7,2.7-2.7h17.5c1.5,0,2.7,1.2,2.7,2.7s-1.2,2.7-2.7,2.7Z"
				/>
			</g>
			<g>
				<path
					className="cls-5"
					d="M512.7,636c-3.7,0-6.8-3-6.8-6.8v-7.1h-7.1c-3.7,0-6.8-3-6.8-6.8s3-6.8,6.8-6.8h7.1v-7.1c0-3.7,3-6.8,6.8-6.8s6.8,3,6.8,6.8v7.1h7.1c3.7,0,6.8,3,6.8,6.8s-3,6.8-6.8,6.8h-7.1v7.1c0,3.7-3,6.8-6.8,6.8Z"
				/>
				<path
					className="cls-4"
					d="M512.7,597.2c2.3,0,4.3,1.9,4.3,4.3v9.6h9.6c2.3,0,4.3,1.9,4.3,4.3s-1.9,4.3-4.3,4.3h-9.6v9.6c0,2.4-1.9,4.3-4.3,4.3s-4.3-1.9-4.3-4.3v-9.6h-9.6c-2.4,0-4.3-1.9-4.3-4.3s1.9-4.3,4.3-4.3h9.6v-9.6c0-2.3,1.9-4.3,4.3-4.3M512.7,592.2c-5.1,0-9.3,4.2-9.3,9.3v4.6h-4.6c-5.1,0-9.3,4.2-9.3,9.3s4.2,9.3,9.3,9.3h4.6v4.6c0,5.1,4.2,9.3,9.3,9.3s9.3-4.2,9.3-9.3v-4.6h4.6c5.1,0,9.3-4.2,9.3-9.3s-4.2-9.3-9.3-9.3h-4.6v-4.6c0-5.1-4.2-9.3-9.3-9.3h0Z"
				/>
			</g>
			<g>
				<path
					className="cls-5"
					d="M542.8,276.5c-.9,0-1.8-.3-2.5-1-1.4-1.4-1.4-3.6,0-4.9l16.1-16.1c1.4-1.4,3.6-1.4,4.9,0,1.4,1.4,1.4,3.6,0,4.9l-16.1,16.1c-.7.7-1.6,1-2.5,1Z"
				/>
				<path
					className="cls-5"
					d="M558.9,276.5c-.9,0-1.8-.3-2.5-1l-16.1-16.1c-1.4-1.4-1.4-3.6,0-4.9,1.4-1.4,3.6-1.4,4.9,0l16.1,16.1c1.4,1.4,1.4,3.6,0,4.9-.7.7-1.6,1-2.5,1Z"
				/>
			</g>
		</svg>
	);
};

export default InboxEmptySvg;
